import { useQuery } from '@tanstack/react-query';

import { assetKeys } from '@/shared/lib/query/queryKeys';

import { fetchLineage } from '@/features/asset-detail/api';

export const useLineage = (entityType: string, fqn: string, enabled: boolean = true) => {
  return useQuery({
    queryKey: assetKeys.lineage(entityType, fqn),
    queryFn: () => {
      if (!enabled) {
        return null;
      }
      return fetchLineage(entityType, fqn);
    },
    staleTime: 5 * 60 * 1000,
    enabled: enabled && !!entityType && !!fqn,
    retry: 1,
  });
};
